import React from "react";
import Modal from "react-modal";
import WeatherModalInner from "./WeatherModalInner";
import { ReactComponent as CloseIcon } from "../../../assets/icons/close.svg";
// import { ReactComponent as XIcon } from "../../svg-icons/x.svg";

function WeatherModal({ forecast, isOpen, setIsOpen, initialSelected }) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      style={{
        overlay: {
          zIndex: "1000",
          backgroundColor: "rgba(0,0,0,0.6)",
        },
        content: {
          width: "100%",
          maxWidth: "580px",
          margin: "0 auto",
          bottom: "unset",
          borderRadius: 0,
          padding: 0,
          overflowX: "hidden",
          backgroundColor: "#ffffff",
          border: "none",
        },
      }}
    >
      {forecast && forecast.length && (
        <WeatherModalInner
          forecast={forecast}
          initialSelected={initialSelected}
        />
      )}

      <button
        type="button"
        className="weather__close"
        onClick={() => setIsOpen(false)}
      >
        <CloseIcon />
      </button>
    </Modal>
  );
}

export default WeatherModal;
